var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnkelsngny01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 239.5 126.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.24 126.12 236.83 126.12 236.83 0 4.24 0 4.24 126.12"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "20.74 21.9 219.16 21.9 219.16 106.95 20.74 106.95 20.74 21.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "102.67 106.92 99.28 106.74 96.07 105.81 91.09 94.98 98.41 66.51 60.16 60.24 56.44 58.53 53.83 52.8 54.91 59.37 79.54 94.98 86.71 102.03 95.59 106.05 98.29 106.62 99.67 106.86 102.67 106.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "53.8 21.9 72.7 21.9 72.7 62.31 60.16 60.24 56.44 58.53 53.83 52.8 53.83 21.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "53.8 35.67 38.41 35.67 29.5 37.26 29.5 91.65 46.75 93.27 62.71 91.95 63.94 72.54 63.94 72.42 54.91 59.37 53.83 52.8 53.8 35.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnkelsngny01);
export default __webpack_public_path__ + "static/media/enkelsäng ny-01.f190aeafad0fa79c4ee4181f98d489cf.svg";
export { ForwardRef as ReactComponent };